// import Backbone from 'backbone';
import tmpl from '../templates';
import ValidationErrorList from '../collections/validationErrorList';

var ValidationErrorController = Backbone.View.extend( {
    template: _.template( tmpl.validationError ),

    childViews: [],

    initialize: function () {
        this.collection = new ValidationErrorList();

        this.listenTo( this, 'error:validation', this.addError.bind( this ) );
        this.listenTo( this, 'clear:validation', this.clearChildViews.bind( this ) );
    },

    close: function () {
        this.stopListening( this.collection );
        this.remove();
    },

    render: function ( model ) {
        var errorView = $( this.template( model.attributes ) );
        model.get( 'el' ).append( errorView );
        return errorView;
    },

    renderList: function () {
        this.clearChildViews();

        this.collection.each( error => {
            this.childViews.push( this.render( error ) );
        } );

        // clear errors
        this.collection.reset();
    },

    addError: function ( error ) {
        //                console.log( error );
        this.collection.add( error );
        this.renderList();
    },

    clearChildViews: function () {
        _.each( this.childViews, function ( view ) {
            view.remove();
        } );
    }
} );

export default ValidationErrorController;
